import React, { useState, useEffect, useRef } from "react";
import { AutoComplete, Button, Space, Input, Form, Select, Spin, Modal, Popover, message, Flex, Checkbox } from "antd";
import ARROR from "@/assets/images/login/arror.svg";
import { debounce } from 'lodash';
import { register, getVerifyCode, getCompany, sendSmsCode, registerByPhone } from '@/apis/login';
import QR_CODE from "@/assets/images/login/qrcode.jpg";
// import THREE_DAY from './images/three_day.png';
// import HUNDRED_COUNT from './images/hundred_count.png';
import SUCCESS from './images/success.png';
import REGISTER_IMG from './images/register_img.svg';
import { useLocation } from 'react-router-dom';
import EyePng from "@/assets/images/login/eye.png";
import HideEyePng from "@/assets/images/login/hide_eye.png";
// import { recordClickType } from "@/apis/record";
// import { clickTypeMapper } from '@/config/constent';
import { usePostHog } from 'posthog-js/react';
import { recordEventRecord } from '@/apis/record';
interface Props {
  propsSetIsLogin?: (value: boolean) => any;
}

type OptionProps = {
  name: string;
}

const formItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};

const DAYS = 'https://ps-cdn.cemeta.cn/configs/frontend/vip_for_newuser.png'
const COUNTS = 'https://ps-cdn.cemeta.cn/configs/frontend/credits_for_newuser.png'

const Register: React.FC<Props> = (props: Props) => {
  const timer = useRef(0);
  const { propsSetIsLogin } = props;

  const searchParamsString = window.location.href.split('?')[1] || '';
  const searchParams = new URLSearchParams(searchParamsString);
  const source = searchParams.get('s'); // source 参数值
  const detail = searchParams.get('d'); // detail 参数值

  const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const [countDown, setCountDown] = useState(60);

  const [submittable, setSubmittable] = React.useState(false);

  const [open, setOpen] = useState(false)

  const values = Form.useWatch([], form);

  const location = useLocation();

  const posthog = usePostHog();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  // 搜索公司
  const debounceHandleSearch = debounce(async (value) => {
    setOptions([]);
    if (!value) {
      return;
    }

    setLoading(true);

    const result = await getCompany({
      search: value,
      limit: 20,
      offset: 0
    }).catch((err) => {
      setLoading(false)
      messageApi.open({
        type: 'error',
        content: err,
      });
    })

    if (Array.isArray(result.list) && result.list.length) {
      setTimeout(() => {
        setOptions(result.list)
        setLoading(false)
      }, 2000)

    } else {
      setOptions([])
      setLoading(false)
    }
  }, 500);

  const jumpLogin = (e) => {
    e?.preventDefault();

    if (timer.current !== null) {
      clearInterval(timer.current)
    }
    propsSetIsLogin?.(true);
  };

  const validateConfirmPassword = (currentValue, form) => {
    const password = form.getFieldValue('password'); // 获取另一个字段的值
    if (password && currentValue && password !== currentValue) {
      return Promise.reject(new Error('两次输入的密码不一致，请重新输入'));
    }

    return Promise.resolve(); // 校验通过
  };

  const validateCompany = (currentValue, form) => {
    // console.log('currentValue', currentValue)
    if (currentValue) {
      if (!currentValue.length) {
        return Promise.reject(new Error('请填写公司名称'));
      } else if (currentValue.length < 2) {
        return Promise.reject(new Error('公司名称长度最少2个字符'));
      } else if (currentValue.length > 30) {
        return Promise.reject(new Error('公司名称长度不超过30个字符'));
      } else {
        return Promise.resolve(); // 校验通过
      }
    } else {
      return Promise.reject(new Error('请填写公司名称'));
    }
  }

  const renderContent = (
    <div className='register-qrcode-alert'>
      <span className='register-qrcode-title'>{'扫码添加客服'}</span>
      <span className='register-qrcode-text' style={{ marginBottom: '12px' }}>{'获取注册邀请码，解锁更多使用权益'}</span>
      <img className='register-qrcode-image' src={QR_CODE} alt="qr-code" />
    </div>
  )

  const timeCountDown = () => {
    setCountDown(countDown - 1)
  }

  useEffect(() => {
    if (countDown !== 60) {
      timer.current = window.setTimeout(() => {
        if (countDown <= 0) {
          timer.current && clearTimeout(timer.current)
          setCountDown(60)
        } else {
          setCountDown(countDown - 1)
        }
      }, 1000)
    }
    return () => {
      timer.current && clearInterval(timer.current)
    }
  }, [countDown])

  const handleVerifyCode = () => {
    // 这里应该要拿到【手机号码或邮箱】的输入框判断是邮箱还是手机，然后调用不同的接口
    const isEmail = values?.email?.includes?.('@')
    if (countDown !== 60) {
      messageApi.open({
        type: 'warning',
        content: `${countDown} + '秒后再试'`,
      });
      return
    }
    form.validateFields(['name', 'email'])
      .then(async ({ email, name }) => {
        const func = isEmail ? getVerifyCode : sendSmsCode
        await func(isEmail ? { email, name } : { phone_number: email, country_code: '86', code_type: 'register' })
          .then(() => {
            messageApi.open({
              type: 'success',
              content: isEmail ? '邮箱验证码已发送，请注意查收' : '手机验证码已发送，请注意查收',
            });
            timeCountDown()
          })
          .catch(err => {
            console.error(err)
            messageApi.open({
              type: 'error',
              content: err,
            });
          })
      })
      .catch((errorInfo) => {
        console.error('errorInfo', errorInfo)
      })
  }

  const handlRegister = () => {
    if (!agree) {
      messageApi.open({
        type: 'warning',
        content: '请先同意用户协议与隐私政策',
      });
      return
    }
    const isEmail = values?.email?.includes?.('@')
    const func = isEmail ? register : registerByPhone
    form.validateFields()
      .then(async values => {
        const { company, ...rest } = values;
        // recordClickType({
        //   event_name: clickTypeMapper.CEMETA_REGISTER
        // }).catch((err) => {
        //   console.error('err', err)
        // })
        if (source && detail) {
          // posthog?.capture('haohui_source_register', {
          //   source: source,
          //   detail: detail,
          // });
          recordEventRecord({
            event_name: 'haohui_source_register',
            source: source,
            event_id: detail,
            tag: {
              invite_code: searchParams.get('y') || '',
            }
          })
        }
        recordEventRecord({ 
          event_name: 'haohui_register',
          tag: {
            invite_code: searchParams.get('y') || '',
          }
        })
        // posthog?.capture('haohui_register', {
        //   type: 'pc',
        //   info: navigator?.userAgent
        // });
        // console.log('values', values)
        await func(isEmail ? {
          ...({ company_name: company }),
          ...rest,
        } : {
          ...({ company_name: company }),
          ...rest,
          phone_number: values?.email,
          email: undefined,
          confirmPassword: undefined,
          country_code: '86',
        }).then(() => {
          // messageApi.open({
          //   type: 'success',
          //   content: '注册成功',
          // });

          setOpen(true)
        })
      })
      .catch(error => {
        // console.log(error)
        const isString = (value: unknown): value is string => typeof value === 'string';
        if (!isString(error)) {
          return
        }
        messageApi?.open({
          type: 'error',
          content: error,
        });
      })
  }

  return (
    <>
      {contextHolder}
      <Form
        className="header-model-form register-model-form"
        {...formItemLayout}
        form={form}
        variant={'filled'}
        size={'large'}
        initialValues={{
          // invite_code: '123',
          invite_code: queryParams?.get('y')
        }}
      >
        <Form.Item style={{ marginBottom: '20px' }}>
          <div className="header-model-form-item-title" style={{ flexDirection: 'row', justifyContent: 'center' }}>
            <img style={{ position: 'absolute', lineHeight: '32px', left: 0 }} src={ARROR} alt="back" onClick={jumpLogin} />
            <div className="header-model-form-item-title-text" style={{ marginTop: '0px', opacity: 1 }}>
              <span>新用户注册</span>
            </div>
          </div>
        </Form.Item>
        <Form.Item
          // label="Input"
          name="name"
          validateFirst
          rules={[
            {
              required: true,
              message: '请输入用户名',
            },
            {
              max: 30,
              message: '用户名长度不超过30个字符'
            },
          ]}
        >
          <Input placeholder='请输入用户名' autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          // label="Input"
          name="email"
          validateFirst
          rules={[
            {
              required: true,
              message: '请输入邮箱',
            },
            {
              validator: (_, value) => {
                // 判断是手机号码或邮箱
                // if (value.includes('@')) {
                const pattern = /^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                return pattern.test(value) ? Promise.resolve() : Promise.reject(new Error('请输入正确的邮箱'))
                // } else {
                //   const pattern = /^1[1-9]\d{9}$/
                //   return pattern.test(value) ? Promise.resolve() : Promise.reject(new Error('请输入正确的手机号码或邮箱'))
                // }
              }
            }
          ]}
        >
          <Input placeholder='请输入邮箱' autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          className="register-form-item-verify-code"
          // label="Input"
          name="verify_code"
          rules={[
            {
              required: true,
              message: '请输入验证码',
            },
            {
              len: 6,
              message: '请输入 6 位验证码'
            }
          ]}
        >
          <Space.Compact
            style={{
              width: '100%',
            }}
          >
            <Input placeholder='请输入验证码' autoComplete="new-password" />
            {countDown === 60
              ? <Button color="primary" variant="text" style={{ height: '48px' }} onClick={handleVerifyCode}>获取验证码</Button>
              : <Button color="primary" variant="text" style={{ height: '48px' }} disabled>{countDown + '(s)后再试'}</Button>}

          </Space.Compact>

        </Form.Item>
        <Form.Item
          // label="Password"
          name="password"
          validateFirst
          rules={[
            {
              required: true,
              message: '请设定密码',
            },
            {
              pattern: /^(?=.*\d)(?=.*[a-zA-Z]).*$/,
              message: '密码需要包含数字和英文'
            },
            {
              min: 8,
              message: '密码长度最少8个字符'
            },
            {
              max: 20,
              message: '密码长度不超过20个字符'
            },
          ]}
        >
          <Input.Password
            placeholder='请设定密码'
            autoComplete="new-password"
            className="register-model-form-password"
            iconRender={(visible) =>
              visible ? (
                <img className="password-icon" src={EyePng} alt="eye" />
              ) : (
                <img className="password-icon" src={HideEyePng} alt="hide-eye" />
              )}
          />
        </Form.Item>
        <Form.Item
          // label="Password"
          name="confirmPassword"
          validateFirst
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: '请再次输入密码',
            },
            {
              validator: (_, value) => validateConfirmPassword(value, form),
            }
          ]}
        >
          <Input.Password
            placeholder='请再次输入密码'
            autoComplete="new-password"
            className="register-model-form-password"
            iconRender={(visible) =>
              visible ? (
                <img className="password-icon" src={EyePng} alt="eye" />
              ) : (
                <img className="password-icon" src={HideEyePng} alt="hide-eye" />
              )}
          />
        </Form.Item>

        <Form.Item
          // label="Password"
          validateFirst
          name="company"
          rules={[
            {
              validator: (_, value) => validateCompany(value, form),
            },
            // {
            //   required: true,
            //   message: '公司名称',
            // },
            // {
            //   min: 2,
            //   message: '公司名称长度最少2个字符'
            // },
            // {
            //   max: 30,
            //   message: '公司名称长度不超过30个字符'
            // },
          ]}
        >
          <AutoComplete
            onSearch={debounceHandleSearch}
            placeholder='公司名称'
            options={options?.map(item => ({ label: item.name, value: item.name }))}
          />
          {/* <Select
            showSearch // 启用搜索功能
            filterOption={false} // 禁用本地过滤，由异步数据控制
            onSearch={debounceHandleSearch}
            getPopupContainer={triggerNode => triggerNode.parentElement}
            notFoundContent={loading ? <Spin size="small" /> : null}
            suffixIcon={null}
            placeholder='公司名称'
            mode="tags"
            // style={{ height: '48px' }}
            maxCount={1}
          >
            {options?.map((option: OptionProps) => (
              <Select.Option key={option?.name} value={option?.name}>
                {option?.name}
              </Select.Option>
            ))}
          </Select> */}
          {/* <Input placeholder='公司名称' autoComplete="new-password" /> */}
        </Form.Item>
        <Form.Item
          className="register-form-item-invite-code"
          // label="Password"
          name="invite_code"
        >
          <Space.Compact
            style={{
              width: '100%',
            }}
          >
            <Input defaultValue={queryParams?.get('y')} placeholder='请输入邀请码（非必填）' autoComplete="new-password" />

            <Popover content={renderContent} title="" trigger="click">
              <Button color="primary" variant="text" style={{ height: '48px' }}>点击获取</Button>
            </Popover>

          </Space.Compact>
        </Form.Item>
        <div className="header-model-footer">
          <Button type="primary" block onClick={handlRegister}>
            注册
          </Button>
          <Flex justify="start" align="center" style={{ marginTop: '14px' }}>
            <Checkbox checked={agree} onChange={(e) => setAgree(e.target.checked)}><span className="agree-text">已阅读并同意 <span style={{ color: "#191919" }}>用户协议</span> 与 <span style={{ color: "#191919" }}>隐私政策</span></span></Checkbox>
          </Flex>
          <div className="header-model-footer-sign" style={{ marginBottom: '10px', marginTop: '48px' }}>
            <span style={{ color: '#888888' }}>已有账号？</span>
            <span style={{ borderBottom: '1px solid #376BFF' }}>
              <a href="" style={{ color: '#376BFF' }} onClick={jumpLogin}>去登录</a>
            </span>
          </div>
        </div>
      </Form>
      {/* 注册成功弹框 modal 1 */}
      {/* <Modal
            className="register-success"
            width={'360px'}
            title={null}
            footer={null}
            open={open}
            maskClosable={false}
            onCancel={() => {setOpen(false);jumpLogin(null)}}
            style={{ zIndex: 1001 }}
      >
        <div className='register-success-header'>
            <img style={{ width: '40px', height: '40px' }} src={SUCCESS} />
            <div className='register-success-header-text'><span>注册成功！</span></div>
        </div>
        <div className='register-success-body'>
            <div className='register-success-body-text'>
                🎉<span>恭喜解锁新手礼包</span>  
            </div>
            <div className='register-success-body-imgs'>
                <img style={{ width: '136px', height: 'auto', marginRight: '12px' }} src={THREE_DAY} />
                <img style={{ width: '136px', height: 'auto' }} src={HUNDRED_COUNT} />
            </div>
        </div>
      </Modal> */}
      {/* 注册成功弹框 modal 2 */}
      <Modal
        className="register-success-modal2"
        title={null}
        footer={null}
        open={open}
        maskClosable={false}
        onCancel={() => { setOpen(false); jumpLogin(null) }}
        style={{ zIndex: 1001 }}
      >
        <div className="register-success-modal2-title">
          新手训练营
        </div>
        <div className="register-success-modal2-image">
          <img src={REGISTER_IMG} />
        </div>
        <div className="register-success-modal2-footer">
          <div className="register-success-modal2-button" onClick={() => { window.open('https://mi8elatzm1x.feishu.cn/wiki/QuEWwjlYyiveRBksz1JcgByKnCd') }}>
            查看详情
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Register;
